import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UserNameLink from 'flow-doctor-lib/components/common/UserNameLink';
import { jsx as _jsx } from "react/jsx-runtime";
const ManualEnrollmentAnalysisReason = ({
  diagnosisReason,
  selectedEnrollment
}) => {
  const enrolledByUserId = diagnosisReason.userId;
  if (!enrolledByUserId) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.MANUAL_ENROLL.withoutUser"
    });
  }
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.MANUAL_ENROLL.withUser_jsx',
      elements: {
        UserNameLink
      },
      options: {
        userNameLink: {
          portalId: selectedEnrollment.portalId,
          userId: enrolledByUserId
        }
      }
    })
  });
};
export default ManualEnrollmentAnalysisReason;